<template>
    <div class="page-wrapper login-page">
        <Header/>
        <div class="wrapper">
            <div class="login-screen">
                <div class="eclipse">
                    <div class="vcenter-container">
                        <div class="vcenter"><img src="../image/eclipse.png"></div>
                    </div>
                </div>
                <div class="container">
                    <div class="content-block">
                        <div>
                            <div>
                                <div class="login-form">
                                    <div class="title">
                                        Регистрация
                                    </div>

                                    <div class="text" v-show="registerStatus == registerStatuses.waiting">
                                        <div class="text">
                                            <div>Пожалуйста, подождите...</div>
                                        </div>
                                    </div>

                                    <div class="error-soc-no-email" v-show="registerStatus == registerStatuses.emailNotFilled">
                                        <div class="text error-registration-text">
                                            <div>В Вашем аккаунте соцсети не заполнен email.</div>
                                        </div>
                                        <div class="error-registration-icon">
                                            <img src="@/image/icon-error.png">
                                        </div>
                                    </div>

                                    <div class="error-soc-email-busy" v-show="registerStatus == registerStatuses.emailTaken">
                                        <div class="text error-registration-text">
                                            <div>В системе уже зарегистрирован аккаунт с таким email.</div>
                                            <div>
                                                Возможно, ранее Вы авторизовались через другую соцсеть. <router-link :to="{name: 'ForgotPassword'}">Восстановить пароль</router-link>.
                                            </div>
                                        </div>
                                        <div class="error-registration-icon">
                                            <img src="@/image/icon-error.png">
                                        </div>
                                    </div>

                                    <div class="error-soc-not-supported" v-show="registerStatus == registerStatuses.providerNotSupported">
                                        <div class="text error-registration-text">
                                            <div>Не поддерживается авторизация через данного провайдера.</div>
                                        </div>
                                        <div class="error-registration-icon">
                                            <img src="@/image/icon-error.png">
                                        </div>
                                    </div>

                                    <div v-show="registerStatus == registerStatuses.other">
                                        <div class="text error-registration-text">
                                            <div>{{ errorMessage }}</div>
                                        </div>
                                        <div class="error-registration-icon">
                                            <img src="@/image/icon-error.png">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="login-screen-bg bg-animation"></div>
            </div>
        </div>
        <Footer :no-footer="true"/>
    </div>
</template>

<script>
    import router from '@/router';
    import store from '@/store';
    import Header from '@/components/Header';
    import Footer from '@/components/Footer';

    const registerStatusesInternal = Object.freeze({
        waiting: 1,
        success: 2,
        emailNotFilled: 3,
        emailTaken: 4,
        providerNotSupported: 5,
        other: 6
    });

    export default {
        name: "OAuth2Result",

        components: {
            Header, Footer
        },

        data() {
            return {
                registerStatuses: registerStatusesInternal,
                registerStatus: registerStatusesInternal.waiting,
                errorMessage: null
            }
        },

        created() {
            this.saveToken()
        },

        methods: {
            async saveToken() {
                let socialToken = this.$route.query.socialToken;
                if (!!socialToken) {
                    await this.$store.dispatch('setSocialToken', socialToken);
                    let isAuthenticated = await store.dispatch('loadCurrentUserData');
                    if (isAuthenticated) {
                        this.registerStatus = this.registerStatuses.success;
                        router.push({name: 'CardCalculate'});
                        return;
                    }
                }

                await this.$store.dispatch('logout');

                let errorCode = this.$route.query.errorCode;
                if (!!errorCode) {
                    switch (errorCode) {
                        case 'email_not_filled':
                            this.registerStatus = this.registerStatuses.emailNotFilled;
                            // errorMessage = 'В Вашем аккаунте соцсети не заполнен email!';
                            break;
                        case 'email_already_exists':
                            this.registerStatus = this.registerStatuses.emailTaken;
                            // errorMessage = 'В системе уже зарегистрирован аккаунт с таким email.\n' +
                            //         'Возможно, ранее Вы авторизовались через другую соцсеть?';
                            break;
                        case 'provider_not_supported':
                            this.registerStatus = this.registerStatuses.providerNotSupported;
                            // errorMessage = 'Не поддерживается авторизация через данного провайдера.';
                            break;
                        default:
                            this.errorMessage = 'Не удалось авторизоваться!';
                            this.registerStatus = this.registerStatuses.other;
                            // errorMessage = 'Не удалось авторизоваться!';
                    }
                } else {
                    this.errorMessage = 'Не удалось авторизоваться!';
                    this.registerStatus = this.registerStatuses.other;
                }

                if (this.registerStatus != this.registerStatuses.emailTaken) {
                    setTimeout(() => {
                        this.$router.push({name: 'Registration'});
                    }, 4000);
                }
            }
        }
    }
</script>
